<template>
  <div class="srm-header flex-box" :class="{ 'is-open': menuOpen, 'is-solid': changeColor || menuOpen }" :style="{background: (changeColor || menuOpen) ? '#fff' : 'transparent'}">
    <div class="company-logo flex-box" @click="() => $router.push('/')">
      <el-image :src="require('@/assets/images/logo.png')" />
    </div>
    <button type="button" class="menu-toggle" :class="{ open: menuOpen }" aria-label="菜单" @click="toggleMenu">
      <span></span><span></span><span></span>
    </button>
    <div class="mobile-mask" v-show="menuOpen" @click="closeMenu"></div>
    <div class="mobile-nav" :class="{ open: menuOpen }">
      <div
        class="mobile-nav-item"
        v-for="(item, index) in menuList"
        :key="'m-' + item.val"
      >
        <div
          class="mobile-nav-label"
          :class="{ 'is-active': isMenuActive(item) }"
          @click="onMobileNavClick(item)"
        >
          <span>{{ item.label }}</span>
          <i
            v-if="item.child"
            class="el-icon-arrow-down"
            :class="{ open: expandedVal === item.val }"
            @click.stop="toggleMobileSub(item)"
          ></i>
        </div>
        <div class="mobile-sub" v-if="item.child && expandedVal === item.val">
          <div
            class="mobile-sub-item"
            v-for="child in item.child"
            :key="child.label"
            @click="onMobileChildClick(child)"
          >{{ child.label }}</div>
        </div>
      </div>
      <div class="mobile-nav-foot">
        <div class="mobile-phone">全国服务热线 <span>4006-160-730</span></div>
        <div class="mobile-cta pointer" @click="toLink(linkMap.demonstrateUrl)">预约演示</div>
      </div>
    </div>
    <div class="srm-menu">
      <div
        class="srm-menu-item pointer inline-flex-box menu-label"
        :class="{ 'is-active': isMenuActive(item) }"
        v-for="(item, index) in pcMenuList"
        :key="item.val || index"
        @click="clickMenuItem(item)"
      >
        <Dropdown
          v-if="item.child"
          :options="item.child"
          :selectedOption="item.label"
          @changeHandle="goMenu"
          @toggleClick="goMenu(item)"
        ></Dropdown>
        <router-link :to="item.url"  v-else-if="item.url" class="m-label">{{ item.label }}</router-link>
        <span v-else class="m-label">{{ item.label }}</span>
      </div>
    </div>
    <div class="srm-relation flex-box">
      <div class="relation-phone flex-box">
        <div class="image-wrap">
          <el-image :src="require('@/assets/images/telephone.png')" />
        </div>
        <div class="phone-number">
          全国服务热线  <br> <span>4006-160-730</span>
        </div>
        
      </div>

      <div class="separation-line"></div>

      <div class="try-use pointer" @click="toLink(linkMap.demonstrateUrl)">
        预约演示
      </div>
    </div>
  </div>
</template>

<script>
import { linkMap } from "@/utils";
import Dropdown from "@/components/Dropdown";

export default {
  name: 'SRM-Header',
  components: {
    Dropdown
  },  
  props: {
    ratio: {
      require: true
    },
    activeVal: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      linkMap: linkMap,

      // 璞华易研PLM（离散行业）  璞华易研PLM（流程行业）
      menuList: [
        {
          label: '璞华易研PLM（流程行业）',
          child: [
            { value: '/ChemicalIndustry', label: '化工材料行业PLM' },
            { value: '/FoodBeverage', label: '食品饮料行业PLM' },
            { value: '/BeautyMakeup', label: '日化美妆行业PLM' },
          ],
          url: '/ChemicalIndustry',
          val: 'chemicalIndustry' 
        },
        {
          label: '璞华易研PLM（离散行业）',
          child: [
            { value: '/Semiconductor', label: '芯片半导体行业PLM' },
            { value: '/ElectronTechnology', label: '电子高科技行业PLM' },
            { value: '/MedicalEquipment', label: '医疗器械行业PLM' },
          ],
          url: '/',
          hash: '#home-characteristic-discrete',
          tab: 'second',
          val: 'purvarPlm'
        },
        {
          label: '研发项目管理PMS',
          url: '/ProjectManagement',
          val: 'projectManagement'
        },
        {
          label: 'Oracle Agile PLM',
          url: '/OracleAgile',
          val: 'oracleAgile'
        },
        {
          label: 'PLM + AI应用',
          child: [
            { value: { name: 'plmAi', params: { section: 'ai-assistant' } }, label: 'AI助手' },
            { value: { name: 'plmAi', params: { section: 'bayes' } }, label: 'AI贝叶斯优化' },
            { value: { name: 'plmAi', params: { section: 'formula' } }, label: '配方推荐' },
            { value: { name: 'plmAi', params: { section: 'spectrum' } }, label: '化学图谱' },
          ],
          url: '/PLMAI',
          val: 'plmAi'
        },
        {
          label: '案例',
          url: '/',
          hash: '#home-logo-wall',
          val: 'cases',
          mobileOnly: true
        },
        {
          label: '新闻资讯',
          url: '/News',
          val: 'news'
        },
        {
          label: '关于我们',
          url: '/AboutUs',
          val: 'aboutUs'
        }
      ],
      changeColor: false,
      menuOpen: false,
      expandedVal: ''
    }
  },
  computed: {
    pcMenuList() {
      return this.menuList.filter(item => !item.mobileOnly)
    }
  },
  watch: {
    $route() {
      this.closeMenu()
    }
  },
  created() {
  },
  mounted() {
    const _this = this
    window.addEventListener('scroll', function () {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      _this.changeColor = scrollTop >= 40
    })
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    document.body.style.overflow = ''
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    // 立即试用
    toLink(url) {
      window.open(url)
    },
    isMenuActive(item) {
      if (this.$route.path === '/') {
        if (this.$route.hash === '#home-characteristic-discrete') {
          return item.val === 'purvarPlm'
        }
        if (this.$route.hash === '#home-logo-wall') {
          return item.val === 'cases'
        }
        return item.val === 'chemicalIndustry'
      }
      if (this.activeVal === item.val) return true
      if (item.url && this.$route.path === item.url) return true
      if (!item.child) return false
      return item.child.some(child => child.value === this.$route.path)
    },
    goMenu(option) {
      if (option && option.hash) {
        this.goHomeAnchor(option)
        return
      }
      const target = option.value || option.url
      const section = target && target.params && target.params.section
      if (section && this.$route.name === target.name) {
        window.dispatchEvent(new CustomEvent('plm-ai-scroll', { detail: { section } }))
        return
      }
      if (target) {
        this.$router.push(target).catch(() => {})
      }
    },
    clickMenuItem(item) {
      if (!item || item.child) return
      if (item.hash) {
        this.goHomeAnchor(item)
        return
      }
      if (!item.url) return
      this.$router.push(item.url).catch(() => {})
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
      document.body.style.overflow = this.menuOpen ? 'hidden' : ''
    },
    closeMenu() {
      this.menuOpen = false
      this.expandedVal = ''
      document.body.style.overflow = ''
    },
    onResize() {
      if (window.innerWidth >= 768) this.closeMenu()
    },
    onMobileNavClick(item) {
      if (item.hash) {
        this.goHomeAnchor(item)
        return
      }
      if (item.url) {
        this.$router.push(item.url).catch(() => {})
        this.closeMenu()
        return
      }
      if (item.child) {
        this.toggleMobileSub(item)
      }
    },
    goHomeAnchor(item) {
      this.closeMenu()
      const hash = item.hash
      const detail = { hash, tab: item.tab }
      const notify = () => {
        this.$nextTick(() => {
          window.dispatchEvent(new CustomEvent('home-scroll-anchor', { detail }))
        })
      }
      if (this.$route.path === '/') {
        if (this.$route.hash !== hash) {
          this.$router.push({ path: '/', hash }).catch(() => {})
        }
        notify()
        return
      }
      this.$router.push({ path: '/', hash }).then(notify).catch(notify)
    },
    toggleMobileSub(item) {
      this.expandedVal = this.expandedVal === item.val ? '' : item.val
    },
    onMobileChildClick(child) {
      this.goMenu(child)
      this.closeMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.srm-header {
  width: 100%;
  height: 6.4rem;
  position: fixed;
  top: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 99;
  border-bottom: 0.1rem solid rgba(73, 73, 73, .1);

  justify-content: space-between;
  padding: 0 8rem;
  box-sizing:border-box;

  .company-logo {
    width: 14rem;
    ::v-deep .el-image {
      width: 100%;
      height: 100%;
      .el-image__inner {
        vertical-align: super !important;
      }

    }
  }

  .srm-menu {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2.2rem;
    font-size: 1.9rem;
    line-height: 1.6rem;
    z-index: 9;

    .srm-menu-item {
      height: 4rem;
      padding-left: 0;
      align-items: center;

      ::v-deep .el-image {
        width: 1.6rem;
        height: 1.6rem;

        .el-image__inner {
          width: inherit;
        }
      }
    }
    .menu-label.is-active {
      .m-label,
      i,
      ::v-deep .dropdown-toggle { color: #FB0000; }
    }

    .menu-label {
      line-height: 4rem;
      .m-label,
      i,
      ::v-deep .dropdown-toggle { color: #333; }
      .m-label {
        // font-weight: 400;
        font-weight: bold;
        text-decoration: none;
      }
      &.is-active,
      &:hover {
        .m-label,
        i,
        ::v-deep .dropdown-toggle { color: #FB0000; }
      }
    }
  }

  .srm-relation {
    align-items: center;

    .relation-phone {
      color: #1385F5;
      font-size: 2.4rem;
      line-height: 2.4rem;
      font-weight: 500;
      flex-direction: row;
      align-items: center;
      margin-right: 2.7rem;
      .image-wrap {
        width: 3.6rem;
        height: 3.6rem;
        background: #FFFFFF;
        border-radius: 50%;
        text-align: center;
        line-height: 3.6rem;
      }
      ::v-deep .el-image {
        width: 1.58rem;
        height: 1.46rem;
        .el-image__inner {
          width: inherit;
        }
      }
      
      .phone-number {
        font-size: 1.4rem;
        margin-left: 1.2rem;
        color: #333333;
        span {
          color: #FB0000;
          font-weight: bold;
          font-size: 1.8rem;
          line-height: 1.8rem;
          height: 1.8rem;
          padding-top: 0.4rem;
        }
      }
    }
    .separation-line {
      width: 0.1rem;
      height: 2.7rem;
      opacity: 0.53;
      border: 0.1rem solid #494949;
    }

    .try-use {
      font-size: 1.4rem;
      color: #fff;
      padding: 1.1rem 3.7rem;
      background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
      border-radius: 2rem;
      line-height: 1.4rem;
      margin-left: 3.2rem;
    }
  }

  @media (min-width: 768px) {
    .menu-toggle,
    .mobile-mask,
    .mobile-nav {
      display: none !important;
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
    .srm-header {
    height: 5.6rem;
    padding: 0 1.6rem !important;
    background: #fff !important;
    overflow: visible;

    .company-logo {
      width: 11rem;
    }

    .srm-menu,
    .srm-relation {
      display: none;
    }

    .menu-toggle {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      width: 4.4rem;
      height: 4.4rem;
      margin-left: auto;
      padding: 0;
      border: 0;
      background: transparent;
      cursor: pointer;
      z-index: 102;

      span {
        display: block;
        width: 2rem;
        height: 0.2rem;
        margin: 0.3rem 0;
        background: #333;
        border-radius: 0.1rem;
        transition: transform .2s, opacity .2s;
      }

      &.open span:nth-child(1) {
        transform: translateY(0.8rem) rotate(45deg);
      }
      &.open span:nth-child(2) {
        opacity: 0;
      }
      &.open span:nth-child(3) {
        transform: translateY(-0.8rem) rotate(-45deg);
      }
    }

    .mobile-mask {
      display: block;
      position: fixed;
      top: 5.6rem;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .35);
      z-index: 100;
    }

    .mobile-nav {
      display: block;
      position: fixed;
      top: 5.6rem;
      right: 0;
      width: 78%;
      max-width: 32rem;
      height: calc(100vh - 5.6rem);
      overflow-y: auto;
      background: #fff;
      z-index: 101;
      padding: 1.2rem 0 2.4rem;
      transform: translateX(100%);
      transition: transform .2s ease;
      box-shadow: -0.4rem 0 1.6rem rgba(0, 0, 0, .08);

      &.open {
        transform: translateX(0);
      }
    }

    .mobile-nav-label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1.4rem 2rem;
      font-size: 1.6rem;
      font-weight: 600;
      color: #333;
      line-height: 2.2rem;

      &.is-active {
        color: #FB0000;
      }

      i {
        flex-shrink: 0;
        padding: 0.6rem 0 0.6rem 1.2rem;
        font-size: 1.4rem;
        transition: transform .2s;
        &.open {
          transform: rotate(180deg);
        }
      }
    }

    .mobile-sub-item {
      padding: 1.2rem 2rem 1.2rem 3.2rem;
      font-size: 1.5rem;
      color: #555;
      line-height: 2.2rem;
    }

    .mobile-nav-foot {
      margin: 1.6rem 2rem 0;
      padding-top: 1.6rem;
      border-top: 0.1rem solid #eee;
    }

    .mobile-phone {
      font-size: 1.4rem;
      color: #333;
      margin-bottom: 1.6rem;
      span {
        display: block;
        margin-top: 0.4rem;
        font-size: 1.8rem;
        font-weight: 700;
        color: #FB0000;
      }
    }

    .mobile-cta {
      text-align: center;
      font-size: 1.5rem;
      color: #fff;
      padding: 1.2rem 0;
      background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
      border-radius: 2rem;
    }
  }
}

</style>
